import styled from 'styled-components';
import { ButtonProps } from '..';

export const ButtonWrapper = styled.button<ButtonProps>`
  text-decoration: ${({ theme, outline, variant }) =>
    outline
      ? theme.Button.type.secondary.variants[variant].default.textDecoration
      : theme.Button.type.primary.variants[variant].default.textDecoration};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'max-content')};
  min-width: ${({ fullWidth }) => (fullWidth ? '100%' : 'max-content')};
  transition: 0.15s all ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: start;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  outline: none;
  cursor: pointer;

  border-radius: ${({ theme, pill }) =>
    pill || theme.Button.isPull ? theme.Button.borderRadius.pill : theme.Button.borderRadius.normal};

  gap: ${({ theme, size }) => `calc(${theme.Button.sizes[size].fontSize} * 0.25)`};

  font-size: ${({ theme, size }) => theme.Button.sizes[size].fontSize};
  font-weight: ${({ theme, size }) => theme.Button.sizes[size].fontWeight};
  line-height: ${({ theme, size }) => theme.Button.sizes[size].lineHeight};
  padding: ${({ theme, size }) => theme.Button.sizes[size].padding};
  background-color: ${({ theme, outline, variant }) =>
    outline
      ? theme.Button.type.secondary.variants[variant].default.backgroundColor
      : theme.Button.type.primary.variants[variant].default.backgroundColor};
  border-color: ${({ theme, outline, variant }) =>
    outline
      ? theme.Button.type.secondary.variants[variant].default.borderColor
      : theme.Button.type.primary.variants[variant].default.borderColor};
  color: ${({ theme, outline, variant }) =>
    outline
      ? theme.Button.type.secondary.variants[variant].default.color
      : theme.Button.type.primary.variants[variant].default.color};

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme, outline, variant }) =>
      outline
        ? theme.Button.type.secondary.variants[variant].disabled.backgroundColor
        : theme.Button.type.primary.variants[variant].disabled.backgroundColor};
    border-color: ${({ theme, outline, variant }) =>
      outline
        ? theme.Button.type.secondary.variants[variant].disabled.borderColor
        : theme.Button.type.primary.variants[variant].disabled.borderColor};
    color: ${({ theme, outline, variant }) =>
      outline
        ? theme.Button.type.secondary.variants[variant].disabled.color
        : theme.Button.type.primary.variants[variant].disabled.color};
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${({ theme, outline, variant }) =>
        outline
          ? theme.Button.type.secondary.variants[variant].hover.backgroundColor
          : theme.Button.type.primary.variants[variant].hover.backgroundColor};
      border-color: ${({ theme, outline, variant }) =>
        outline
          ? theme.Button.type.secondary.variants[variant].hover.borderColor
          : theme.Button.type.primary.variants[variant].hover.borderColor};
      color: ${({ theme, outline, variant }) =>
        outline
          ? theme.Button.type.secondary.variants[variant].hover.color
          : theme.Button.type.primary.variants[variant].hover.color};
    }
    &:focus,
    &:active,
    &.active {
      outline: 0;
      box-shadow: none;
      background-color: ${({ theme, outline, variant }) =>
        outline
          ? theme.Button.type.secondary.variants[variant].active.backgroundColor
          : theme.Button.type.primary.variants[variant].active.backgroundColor};
      border-color: ${({ theme, outline, variant }) =>
        outline
          ? theme.Button.type.secondary.variants[variant].active.borderColor
          : theme.Button.type.primary.variants[variant].active.borderColor};
      color: ${({ theme, outline, variant }) =>
        outline
          ? theme.Button.type.secondary.variants[variant].active.color
          : theme.Button.type.primary.variants[variant].active.color};
    }
  }
`;
